module.exports = __webpack_public_path__ + "img/Edit Icon - white.f612df1a.svg";